import { render, staticRenderFns } from "./ExportEndurance.vue?vue&type=template&id=720a794f&"
import script from "./ExportEndurance.vue?vue&type=script&lang=js&"
export * from "./ExportEndurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports